function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeWidth: 3
}, React.createElement("path", {
  d: "M12 17.47L3 10.02M11.75 2.223L3 10.02"
}));

function SvgIconChevronLeft(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTUgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDIpIj48cGF0aCBkPSJtOC4yMjQxMzc5MyA3LjI0NTM1ODA5LTcuNDQ4Mjc1ODYgOS4wMDAwMDAwMSIgdHJhbnNmb3JtPSJtYXRyaXgoMCAxIC0xIDAgMTYuMjQ1MzU4IDcuMjQ1MzU4KSIvPjxwYXRoIGQ9Im04Ljc1LjIyMjgxMTY3LTguNzUgNy43OTg0MDg0OSIvPjwvZz48L3N2Zz4K";
export { SvgIconChevronLeft as ReactComponent };